import { MaterialModule } from '../material/material.module';
import { ErrorDialogService } from './error-dialog.service';
import { NgModule } from '@angular/core';
import { ErrorDialogComponent } from './error-dialog.component';

@NgModule({
    imports: [MaterialModule],
    exports: [ErrorDialogComponent],
    declarations: [ErrorDialogComponent],
    providers: [ErrorDialogService]
})
export class ErrorDialogModule {}
